/**
 * `.catch()` handler for static server function calls with a dynamic input (e.g. a product handle from the URL).
 *
 * In the static build, a static server function's results exist only for the inputs used at build time (prerendering).
 * For any other input (e.g. /product/unknown) the result file is missing, so the host answers with its 404 page, which
 * staticFunctionMiddleware tries to parse as JSON (it does not check the response status): that is a `SyntaxError`.
 * Other errors (e.g. network ones, `TypeError`) are rethrown.
 *
 * @example
 * const product = await getProduct({ data: { handle } }).catch(nullIfNotPrerendered);
 * if (!product) throw notFound();
 */
export function nullIfNotPrerendered(error: unknown): null {
  if (error instanceof SyntaxError) {
    return null;
  }

  throw error;
}
